<template>
  <div>
    <app-datatable
      add-permission="add_customer"
      :headers="datatable.headers"
      :end-point="endPoint"
      :table-slots="datatable.tableSlots"
      :reset-table-data="datatable.resetTableData"
      :update-table-data="datatable.updateTableData"
      @data-loaded="handleDataLoaded()"
      @add-new="addNew()"
    >
      <template v-slot:block="slotProp">
        <v-switch
          v-model="slotProp.item.block"
          dense
          inset
          class="mt-0"
          hide-details
          color="warning"
          :ripple="false"
          @change="blockUnblock(slotProp.item.id)"
        />
      </template>

      <template v-slot:old_loan="slotProp">
        {{ $_format_number(slotProp.item.old_loan) }}
      </template>

      <template v-slot:created_at="slotProp">
        <span class="d-inline-block dir-ltr">
          {{ $_format_date(slotProp.item.created_at) }}
        </span>
      </template>

      <!-- Actions -->
      <template
        v-if="$_cans(['change_customer', 'delete_customer'])"
        v-slot:actions="slotProp"
      >
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              v-bind="attrs"
              v-on="on"
            >
              <v-icon>mdil-dots-vertical</v-icon>
            </v-btn>
          </template>

          <v-list dense>
            <v-list-item
              v-if="$_can('change_customer')"
              @click="updateRow(slotProp.item)"
            >
              <v-list-item-icon class="me-2">
                <v-icon
                  small
                  color="info"
                  class="fs-18"
                >
                  mdil-pencil
                </v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>
                  {{ $t('Edit') }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
              v-if="$_can('change_customer')"
              @click="changeReceiptDate(slotProp.item)"
            >
              <v-list-item-icon class="me-2">
                <v-icon
                  small
                  color="warning"
                  class="fs-18"
                >
                  mdil-calendar
                </v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>
                  {{ $t('Does not pay this month') }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
              v-if="$_can('delete_customer')"
              @click="deleteRow(slotProp.item.id)"
            >
              <v-list-item-icon class="me-2">
                <v-icon
                  small
                  color="error"
                  class="fs-18"
                >
                  mdil-delete
                </v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>
                  {{ $t('Delete') }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
    </app-datatable>

    <!------------------- Dialogs ------------------->
    <add-edit
      :add-edit-dialog="addEditDialog"
      :form-data="formData"
      :edit-mode="editMode"
      @close="addEditDialog = false"
      @reset-table-data="datatable.resetTableData = true"
      @update-table-data="datatable.updateTableData = true"
    />

    <change-next-receipt-date
      :change-next-receipt-date-dialog="changeNextReceiptDateDialog"
      :form-data="formData"
      @close="changeNextReceiptDateDialog = false"
    />
  </div>
</template>

<script>
import axios from 'axios'
import AddEdit from './AddEdit.vue'
import ChangeNextReceiptDate from './ChangeNextReceiptDate.vue'

export default {
  components: {
    AddEdit,
    ChangeNextReceiptDate,
  },

  data() {
    return {
      addEditDialog: false,
      changeNextReceiptDateDialog: false,
      formData: {},
      editMode: false,
      id: 0,
      datatable: {
        resetTableData: false,
        updateTableData: false,
        headers: [
          { text: this.$t('Name'), value: 'name', sortable: true },
          { text: this.$t('Phone 1'), value: 'phone1', sortable: true },
          { text: this.$t('Phone 2'), value: 'phone2', sortable: true },
          { text: this.$t('Occupation'), value: 'occupation', sortable: true },
          { text: this.$t('Old Loan'), value: 'old_loan', sortable: true },
          { text: this.$t('Address'), value: 'address', sortable: true },
          { text: this.$t('Guarantor Name'), value: 'guarantor_name', sortable: true },
          { text: this.$t('Guarantor Phone'), value: 'guarantor_phone', sortable: true },
          { text: this.$t('Guarantor Address'), value: 'guarantor_address', sortable: true },
          { text: this.$t('Guarantor Occupation'), value: 'guarantor_occupation', sortable: true },
          { text: this.$t('Guarantor Place'), value: 'guarantor_place', sortable: true },
          { text: this.$t('Guarantor Number'), value: 'guarantor_number', sortable: true },
          { text: this.$t('Document'), value: 'document', sortable: true },
          { text: this.$t('Note'), value: 'note', sortable: true },
          { text: this.$t('Block'), value: 'block', sortable: true },
          { text: this.$t('User'), value: 'user', sortable: true },
          { text: this.$t('Created At'), value: 'created_at', sortable: true },
          { text: this.$t('Actions'), value: 'actions', sortable: false, align: 'center' },
        ],
        tableSlots: [
          'block',
          'old_loan',
          'created_at',
          'actions',
        ]
      },
      endPoint: 'customer/'
    }
  },

  mounted() {
    this.$_section_title({ title: 'Customers', icon: 'mdil-account' })
  },

  methods: {
    handleDataLoaded() {
      this.datatable.resetTableData = false
      this.datatable.updateTableData = false
    },

    addNew() {
      this.formData = {}
      this.editMode = false
      this.addEditDialog = true
    },

    updateRow(data) {
      this.formData = { ...data }
      this.editMode = true
      this.addEditDialog = true
    },

    changeReceiptDate(data) {
      axios.get(`customer/${data.id}/get-current-monthly-plan`).then(res => {
        this.formData = {
          ...res.data,
          customer_name: data.name
        }
        this.changeNextReceiptDateDialog = true
      })
    },

    deleteRow(id) {
      this.$_confirm().then(confirmed => {
        if (confirmed) {
          axios.delete(this.endPoint + id + '/').then(() => {
            this.$_notify('Deleted successfully')
            this.datatable.resetTableData = true
          })
        }
      })
    },

    blockUnblock(id) {
      axios.get(`customer/${id}/block_unblock/`).then(() => {
        this.$_notify('Done successfully')
        this.datatable.updateTableData = true
      })
    }
  },
}
</script>

<style lang="scss" scoped>
</style>